module.exports = __webpack_public_path__ + "media/images/new_landing/people/martin-kyncl-84d3968dbdc67a0982bc6d71620faccb.jpg";